import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoFor } from './components/WhoFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // SEO-optimized page title (under 60 chars, primary keyword first)
    const pageTitle = 'The 48-Hour Airbnb Cleanup Protocol | 5-Star Turnover in 120 Minutes';
    document.title = pageTitle;
    // SEO-optimized meta description (under 160 chars, includes benefit + keyword + price)
    const metaDescription = 'The step-by-step emergency cleaning system for solo Airbnb hosts. Finish a 5-star turnover in under 120 minutes — even alone. Instant PDF download for $6.36.';
    // Helper to upsert a meta tag
    const setMetaTag = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    // Standard SEO
    setMetaTag('name', 'title', pageTitle);
    setMetaTag('name', 'description', metaDescription);
    setMetaTag('name', 'keywords', 'Airbnb cleaning checklist, Airbnb turnover protocol, short-term rental cleaning, Superhost cleaning guide, Airbnb cleaning system, vacation rental cleaning PDF');
    // Open Graph (Facebook, LinkedIn, etc.)
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:title', pageTitle);
    setMetaTag('property', 'og:description', metaDescription);
    setMetaTag('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/6zswByJzs2XWdCc2bmvTJD/heylloyd-image-1778928817369.png');
    // Twitter Card
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', pageTitle);
    setMetaTag('name', 'twitter:description', metaDescription);
    setMetaTag('name', 'twitter:image', 'https://cdn.magicpatterns.com/uploads/6zswByJzs2XWdCc2bmvTJD/heylloyd-image-1778928817369.png');
  }, []);
  return <div className="min-h-screen bg-brand-dark selection:bg-brand-yellow selection:text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <WhyFailed data-id="element-3" />
      <Mechanism data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <Offer data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}